'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '~/components/ui/dialog';
import { Button } from '~/components/ui/button';
export const ModalAlert = t0 => {
  const $ = _c(34);
  const {
    visible,
    title,
    message,
    buttons: t1,
    loading: t2,
    onClose
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [{
      text: "OK"
    }] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const buttons = t3;
  const loading = t2 === undefined ? false : t2;
  const [isVisible, setIsVisible] = useState(visible);
  let t4;
  let t5;
  if ($[2] !== visible) {
    t4 = () => {
      setIsVisible(visible);
    };
    t5 = [visible];
    $[2] = visible;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] !== loading || $[6] !== onClose) {
    t6 = button => {
      if (loading || button.loading) {
        return;
      }
      button.onClick?.();
      setIsVisible(false);
      onClose();
    };
    $[5] = loading;
    $[6] = onClose;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleButtonClick = t6;
  let t7;
  if ($[8] !== loading || $[9] !== onClose) {
    t7 = () => {
      if (loading) {
        return;
      }
      setIsVisible(false);
      onClose();
    };
    $[8] = loading;
    $[9] = onClose;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleBackdropPress = t7;
  const getButtonVariant = _temp;
  let t8;
  if ($[11] !== handleBackdropPress) {
    t8 = open => !open && handleBackdropPress();
    $[11] = handleBackdropPress;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== loading) {
    t9 = loading && <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-900" />;
    $[13] = loading;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9 || $[16] !== title) {
    t10 = <DialogTitle className="text-lg font-semibold text-center flex items-center justify-center gap-2">{t9}{title}</DialogTitle>;
    $[15] = t9;
    $[16] = title;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== message) {
    t11 = message && <DialogDescription className="text-sm text-center mt-2">{message}</DialogDescription>;
    $[18] = message;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <DialogHeader className="text-center">{t10}{t11}</DialogHeader>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== buttons || $[24] !== handleButtonClick || $[25] !== loading) {
    t13 = <div className="pt-0">{loading && buttons.length === 0 ? <div className="flex justify-center items-center py-4"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" /></div> : <div className={`flex ${buttons.length > 1 ? "flex-row" : "flex-col"} gap-3`}>{buttons.map((button_0, index) => <Button key={index} variant={getButtonVariant(button_0.style)} className={`${buttons.length > 1 ? "flex-1" : "w-full"} ${button_0.style === "destructive" ? "bg-red-500 hover:bg-red-600" : ""}`} disabled={loading || button_0.loading} onClick={() => handleButtonClick(button_0)}>{button_0.loading && <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />}{button_0.text}</Button>)}</div>}</div>;
    $[23] = buttons;
    $[24] = handleButtonClick;
    $[25] = loading;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <DialogContent className="w-full max-w-md">{t12}{t13}</DialogContent>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isVisible || $[31] !== t14 || $[32] !== t8) {
    t15 = <Dialog open={isVisible} onOpenChange={t8}>{t14}</Dialog>;
    $[30] = isVisible;
    $[31] = t14;
    $[32] = t8;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
function _temp(style) {
  switch (style) {
    case "destructive":
      {
        return "default";
      }
    case "cancel":
      {
        return "ghost";
      }
    default:
      {
        return "primary";
      }
  }
}